export default "__VITE_ASSET__eok65yPY__"